// Do NOT put MailerSend API tokens here — they ship in the browser bundle.
// Assignment emails use MAILERSEND_API_TOKEN on the therapistProfilePhotoResolver Lambda.

// Add other non-secret configuration here
export const EMAIL_CONFIG = {
  from: {
    email: 'info@tinywins.ai',
    name: 'TinyWins'
  },
  replyTo: {
    email: 'support@tinywins.ai',
    name: 'TinyWins Support'
  }
};
